import type { ScanMiniPrescription } from '@MP/shared/api/hooks/scanMini';
import { ScanMiniPrescriptionStatus } from '@MP/shared/api/hooks/scanMini';

const PrescriptionUtils = {
  canDeletable: (prescription: ScanMiniPrescription) => {
    const status = prescription.status;
    return (
      status === ScanMiniPrescriptionStatus.Completed ||
      status === ScanMiniPrescriptionStatus.Cancelled ||
      status === ScanMiniPrescriptionStatus.AnalysisFailed
    );
  },
  canCreate: (prescriptions: ScanMiniPrescription[] = []) => {
    const isInProgress = prescriptions.some((v) => {
      const status = v.status;
      return status === ScanMiniPrescriptionStatus.InProgress || status === ScanMiniPrescriptionStatus.Waiting;
    });
    return !isInProgress;
  },
  hasInProgress: (prescriptions: ScanMiniPrescription[] = []) => {
    return prescriptions.some((v) => {
      const status = v.status;
      return status === ScanMiniPrescriptionStatus.InProgress || status === ScanMiniPrescriptionStatus.Waiting;
    });
  },
};

export default PrescriptionUtils;
